export default __webpack_public_path__ + "static/media/99.083218fb.png";